import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';

import { Page404Component } from './extrapages/page404/page404.component';
import { AccountRoutingModule } from './account/account-routing.module';
import { BackUpComponent } from './back/back-up/back-up.component';

const routes: Routes = [
  

  // Redirección inicial
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },

  // Módulo principal protegido
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () =>
      import('./pages/pages.module').then(m => m.PagesModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },

  // Páginas adicionales
  {
    path: 'pages',
    loadChildren: () =>
      import('./extrapages/extrapages.module').then(m => m.ExtrapagesModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },

  // Página 404
  {
    path: '**',
    component: Page404Component
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', relativeLinkResolution: 'legacy' }),AccountRoutingModule],
  exports: [RouterModule]
})

export class AppRoutingModule { }
